/**
 * contiene la información para el manejo de sga completo.
 */
export const defaultSgaCompleto = () => {
  return {
    almacenamiento: '',
    clasePeligro: '',
    clasificacionPictograma: '',
    eliminacion: '',
    indicaciones: '',
    intervencion: '',
    palabraSga: '',
    prevencion: '',
  };
};

/**
 * Carga todas las variables declaradas en el proceso.
 */
export default {
  selectedSgaCompleto: defaultSgaCompleto(),
  idioma: {
    seleccionado: 'Espanol'
  },
  version: 6,
  clasificacionSGAListas: {
    sinSGA: ''
  },
  visibilidadSgaCompleto: false,
  visibilidadFrasesSga: false
};
